module.exports = __webpack_public_path__ + "img/28.60f95b4e.jpg";